import { createStyles, Theme } from '@material-ui/core'
import { transition } from '../../../../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'
import { lighten } from '@material-ui/core/styles/colorManipulator'

export const useMyAccountMenuStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(1),
      minWidth: 220,
      '& .MuiPaper-root': {
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[8],
        border: `1px solid ${theme.palette.divider}`,
        boxSizing: 'border-box',
        padding: theme.spacing(0.5, 1.5),
        overflowX: 'hidden',
        overflowY: 'auto',
      },
      '& .MuiMenuItem-root': {
        padding: theme.spacing(1.25, 2),
        minHeight: 48,
        fontSize: '0.9375rem',
        fontWeight: 600,
        margin: theme.spacing(0.25, 0),
        borderRadius: theme.shape.borderRadius * 2,
        transition: transition,
      },
      '& .MuiMenuItem-root:not($logoutMenuItem)': {
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          transform: 'translateX(4px)',
          '& a': {
            color: theme.palette.common.white,
          },
          '& $iconHolder': {
            color: theme.palette.common.white,
            '& .MuiSvgIcon-root': {
              color: theme.palette.common.white,
            },
          },
        },
        '&:active': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '& a': {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        minWidth: 0,
        fontWeight: 600,
        fontSize: '0.9375rem',
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        transition: transition,
        'svg path': {
          fill: 'inherit !important',
        },
      },
      '& hr': {
        margin: theme.spacing(1, 0),
        borderColor: theme.palette.divider,
      },
      '& li': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    iconHolder: {
      marginBottom: 0,
      paddingRight: theme.spacing(1.5),
      color: lighten(theme.palette.primary.main, 0.14),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 24,
      transition: transition,
      '& .MuiSvgIcon-root': {
        fontSize: '1.25rem',
      },
    },
    logoutMenuItem: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        transform: 'translateX(4px)',
        '& $iconHolder': {
          color: theme.palette.common.white,
          '& .MuiSvgIcon-root': {
            color: theme.palette.common.white,
          },
        },
        '& $logoutText': {
          color: theme.palette.common.white,
        },
      },
      '&:active': {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        '& $iconHolder': {
          color: theme.palette.common.white,
          '& .MuiSvgIcon-root': {
            color: theme.palette.common.white,
          },
        },
        '& $logoutText': {
          color: theme.palette.common.white,
        },
      },
    },
    logoutText: {
      color: theme.palette.text.primary,
      fontWeight: 600,
      fontSize: '0.9375rem',
      transition: transition,
    },
  })
)
